import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
    E,
    userManager,
    useUser,
    usePortfolio,
    useAppAuth
} from '../../logic/imports';

export const Navbar: React.FC = () => {
    const navigate = useNavigate();
    const { logout } = useAppAuth();
    const { userData } = useUser();
    const { isConnected } = usePortfolio() || { isConnected: false };

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [tradingEnabled, setTradingEnabled] = useState(false);

    useEffect(() => {
        const tosAccepted = (userData?.tosVersion ?? 0) > 0;
        setIsLoggedIn(tosAccepted);
        
        // Check grants and Public connection status
        const portfolioConnected = isConnected;
        const hasTraderGrant = userData?.grants.includes(E.Grant.TRADER) || false;
        setTradingEnabled(portfolioConnected && hasTraderGrant);
    }, [userData, isConnected]);
    
    const handleLogout = async () => {
        // console.log("[Navbar] Logging out...");
        
        // Log out from Auth0
        await logout();
        // Clear any pending auth state
        await userManager.disconnect();
        // Redirect to login with implicit message
        navigate('/');
    };

    return (
        <nav className="navbar-container">
            <div className="navbar-contents">
                {isLoggedIn && (
                    <>
                        {/* Dashboard */}
                        <NavLink
                            to="/dashboard"
                            className={({ isActive }) =>
                                isActive
                                    ? "navbar-button navbar-button--active" 
                                    : "navbar-button"
                            }
                        >
                            Dashboard
                        </NavLink>

                        {/* Trading */}
                        {/* {hasTradingGrant && (
                            <NavLink
                                to="/trading"
                                className={({ isActive }) =>
                                    isActive
                                        ? "navbar-button navbar-button--active"
                                        : "navbar-button"
                                }
                            >
                                Trading
                            </NavLink>
                        )} */}

                        {/* SPY Trading */}
                        {tradingEnabled && (
                            <NavLink
                                to="/quicktrading"
                                className={({ isActive }) =>
                                    isActive
                                        ? "navbar-button navbar-button--active"
                                        : "navbar-button"
                                }
                            >
                                SPY
                            </NavLink>
                        )}

                        {/* Scanner */}
                        {tradingEnabled && (
                            <NavLink
                                to="/scanner"
                                className={({ isActive }) =>
                                    isActive
                                        ? "navbar-button navbar-button--active"
                                        : "navbar-button"
                                }
                            >
                                Scanner
                            </NavLink>
                        )}

                        {/* Logout Button */}
                        <button
                            onClick={handleLogout}
                            className="navbar-button"
                            style={{
                                color: '#ff402bff',
                            }}
                        >
                            Logout
                        </button>
                    </>
                )}
            </div>
        </nav>
    );
}
